import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { BProps, DataTypeB0101 } from 'store/ducks/Reportings/types';
import { columnsB0101 } from 'constants/reportColumns';

const B0101: React.FC<BProps> = ({ entityName }) => {
  const { date, is_displayed } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeB0101[]>([]);
  const dispatch = useDispatch();
  const fetchData = async () => {
    dispatch(set_isDisplayed(false));

    const entityIds: string[] = entityName
      ? entityName.split(',').map((id) => id.trim())
      : [];

    const params = {
      entityId: entityIds,
      date,
    };

    try {
      const fetchedData = await reportingOp.fetchRT0101(params);

      if (fetchedData && fetchedData.entities) {
        const allEntities = Object.values(fetchedData.entities).flat();
        const dateValue = fetchedData.date;

        const formattedData = allEntities.map(
          (dataItem: any, index: number) => ({
            key: index,
            date: dateValue ?? '',
            lei_entity: dataItem.lei_entity ?? dataItem.entity_id ?? '',
            entity_name: dataItem.entity_name,
            iso_code: dataItem.iso_code?.slice(0, 2),
            entity_type: dataItem.entity_type,
            competent_authority: dataItem.competent_authority,
            reporting_date: dataItem.reporting_date,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching RT-01-01:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_displayed, entityName]);

  return (
    <>
      <Table
        columns={columnsB0101}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default B0101;
